import React, {Fragment, useEffect, useState} from 'react';
import {Link, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {login} from '../../actions/auth';
import loginImage from "../../assets/img/login.svg";

const Login = ({login, auth: {isAuthenticated, loading, user}}) => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [errors, setErrors] = useState({});

    const handleFromValidation = () => {
        const {email, password} = formData;
        let errors = {};
        let formIsValid = true;

        const validEmailRegex = RegExp(
            /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i)

        // Email Validation
        if (!email) {
            formIsValid = false;
            errors.email = "*Please Enter Your Email";
        } else if (!validEmailRegex.test(email)) {
            formIsValid = false;
            errors.email = "*Please Enter Valid Email...!";
        }
        if (!password) {
            formIsValid = false;
            errors.password = "*Please Enter your Password...!";
        }

        setErrors(errors);
        return formIsValid;
    };

    const {email, password} = formData;

    const onChange = e =>
        setFormData({...formData, [e.target.name]: e.target.value});

    const onSubmit = e => {
        e.preventDefault();
        if (handleFromValidation()) {
            login(email, password);
        }

    };
    if (isAuthenticated && localStorage.vip_token) {
        return <Redirect to="/private-chat"/>;
    }



    return (
        <Fragment>
            <div className="card w-50 login-card mt-5 mx-auto">
                <img src={loginImage} className="w-25 mx-auto mt-5" alt="Data Not Found"/>
                <div className="card-body">
                    <form className="form" onSubmit={onSubmit}>
                        <div className="form-group">
                            <label>Email</label>
                            <input type="email" name="email" value={email}
                                   className="form-control" onChange={onChange} placeholder="Enter email"/>
                            {errors.email && <span className='text-danger'>{errors.email}</span>}
                        </div>
                        <div className="form-group">
                            <label>Password</label>
                            <input type="password" name="password" value={password}
                                   className="form-control" onChange={onChange} placeholder="Enter password"/>
                            {errors.password && <span className='text-danger'>{errors.password}</span>}
                        </div>
                        {/* <div className="form-group">
                                <div className="custom-control custom-checkbox">
                                    <input type="checkbox" className="custom-control-input" id="customCheck1"/>
                                    <label className="custom-control-label" htmlFor="customCheck1">Remember me</label>
                                </div>
                            </div>*/}

                        <button type="submit" className="btn btn-dark btn-lg btn-block">Sign in</button>
                        <div className="d-flex justify-content-between my-2">
                            <p className="">
                                <Link to="/forgot-password">Forgot Password?</Link>

                            </p>
                        </div>

                    </form>
                </div>
            </div>
        </Fragment>
    );
};

Login.propTypes = {
    login: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool
};

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    auth: state.auth
});

export default connect(mapStateToProps, {login})(Login);
